import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

let env = 'development';
// crappy env check here
if (
  ['auth.onearly.com', 'auth.bloodygoodtests.com.au'].indexOf(
    window.location.host,
  ) !== -1
) {
  env = 'production';
} else if (
  ['auth.staging.onearly.com', 'auth.staging.bloodygoodtests.com.au'].indexOf(
    window.location.host,
  ) !== -1
) {
  env = 'staging';
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App env={env} />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
